// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.remote-camera-control-panel {
  position: absolute;
  width: 156px;
  height: 120px;
  bottom: 10vh;
  right: 5vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #000;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(26, 26, 26, 0.8);
}
.remote-camera-control-panel .control-title {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 700;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
  flex-shrink: 0;
  padding: 5px 15px;
  cursor: move;
}
.remote-camera-control-panel .control-wrap {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
}
.remote-camera-control-panel .control-wrap .zoom-control {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  width: 24px;
  height: 68px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  padding: 1px 0;
}
.remote-camera-control-panel .control-wrap .zoom-control .ant-btn-icon-only {
  width: 20px;
  height: 32px;
  border: none;
  color: #747487;
  border-radius: 5px;
}
.remote-camera-control-panel .control-wrap .zoom-control .ant-btn-icon-only:hover {
  background: #ffffff17;
  color: #fff;
}
.remote-camera-control-panel .control-wrap .zoom-control .ant-btn-icon-only:active {
  background: #ffffff2e;
  color: #fff;
}
.remote-camera-control-panel .control-wrap .pan-control {
  width: 72px;
  height: 72px;
  position: relative;
}
.remote-camera-control-panel .control-wrap .pan-control .pan-control-btn {
  width: 24px;
  height: 24px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  padding: 1px;
  position: absolute;
}
.remote-camera-control-panel .control-wrap .pan-control .turn-up {
  top: 0;
  left: 24px;
  border-radius: 6px 6px 0 0;
  border-bottom: none;
}
.remote-camera-control-panel .control-wrap .pan-control .turn-left {
  top: 24px;
  left: 0;
  border-radius: 6px 0 0 6px;
  border-right: none;
}
.remote-camera-control-panel .control-wrap .pan-control .center-button {
  top: 24px;
  left: 24px;
  border: none;
}
.remote-camera-control-panel .control-wrap .pan-control .turn-right {
  top: 24px;
  left: 48px;
  border-radius: 0 6px 6px 0;
  border-left: none;
}
.remote-camera-control-panel .control-wrap .pan-control .turn-down {
  top: 48px;
  left: 24px;
  border-radius: 0 0 6px 6px;
  border-top: none;
}
.remote-camera-control-panel .control-wrap .pan-control .ant-btn-icon-only {
  width: 20px;
  height: 20px;
  border: none;
  color: #747487;
  border-radius: 5px;
}
.remote-camera-control-panel .control-wrap .pan-control .ant-btn-icon-only:hover {
  background: #ffffff17;
  color: #fff;
}
.remote-camera-control-panel .control-wrap .pan-control .ant-btn-icon-only:active {
  background: #ffffff2e;
  color: #fff;
}

.remote-control-dropdown {
  position: absolute;
  top: 3vh;
  left: 3vw;
  width: 30px !important;
  height: 30px !important;
  border: none;
}
.remote-control-dropdown > * {
  font-size: 18px !important;
  color: #439a97;
}`, "",{"version":3,"sources":["webpack://./src/feature/video/components/remote-camera-control.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2CAAA;EACA,iCAAA;AACF;AACE;EACE,eAAA;EACA,+BAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;AACJ;AACE;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,WAAA;AACJ;AAAI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2CAAA;EACA,cAAA;AAEN;AADM;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AAGR;AAFQ;EACE,qBAAA;EACA,WAAA;AAIV;AAFQ;EACE,qBAAA;EACA,WAAA;AAIV;AAAI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAEN;AADM;EACE,WAAA;EACA,YAAA;EACA,2CAAA;EACA,YAAA;EACA,kBAAA;AAGR;AADM;EACE,MAAA;EACA,UAAA;EACA,0BAAA;EACA,mBAAA;AAGR;AADM;EACE,SAAA;EACA,OAAA;EACA,0BAAA;EACA,kBAAA;AAGR;AADM;EACE,SAAA;EACA,UAAA;EACA,YAAA;AAGR;AADM;EACE,SAAA;EACA,UAAA;EACA,0BAAA;EACA,iBAAA;AAGR;AADM;EACE,SAAA;EACA,UAAA;EACA,0BAAA;EACA,gBAAA;AAGR;AADM;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AAGR;AAFQ;EACE,qBAAA;EACA,WAAA;AAIV;AAFQ;EACE,qBAAA;EACA,WAAA;AAIV;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AACF;AAAE;EACE,0BAAA;EACA,cAAA;AAEJ","sourcesContent":[".remote-camera-control-panel {\n  position: absolute;\n  width: 156px;\n  height: 120px;\n  bottom: 10vh;\n  right: 5vw;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: #000;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(26, 26, 26, 0.8);\n\n  .control-title {\n    font-size: 10px;\n    color: rgba(255, 255, 255, 0.8);\n    font-weight: 700;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    width: 100%;\n    overflow: hidden;\n    flex-shrink: 0;\n    padding: 5px 15px;\n    cursor: move;\n  }\n  .control-wrap {\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    width: 100%;\n    .zoom-control {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: space-around;\n      width: 24px;\n      height: 68px;\n      border-radius: 6px;\n      border: 1px solid rgba(255, 255, 255, 0.12);\n      padding: 1px 0;\n      .ant-btn-icon-only {\n        width: 20px;\n        height: 32px;\n        border: none;\n        color: #747487;\n        border-radius: 5px;\n        &:hover {\n          background: #ffffff17;\n          color: #fff;\n        }\n        &:active {\n          background: #ffffff2e;\n          color: #fff;\n        }\n      }\n    }\n    .pan-control {\n      width: 72px;\n      height: 72px;\n      position: relative;\n      .pan-control-btn {\n        width: 24px;\n        height: 24px;\n        border: 1px solid rgba(255, 255, 255, 0.12);\n        padding: 1px;\n        position: absolute;\n      }\n      .turn-up {\n        top: 0;\n        left: 24px;\n        border-radius: 6px 6px 0 0;\n        border-bottom: none;\n      }\n      .turn-left {\n        top: 24px;\n        left: 0;\n        border-radius: 6px 0 0 6px;\n        border-right: none;\n      }\n      .center-button {\n        top: 24px;\n        left: 24px;\n        border: none;\n      }\n      .turn-right {\n        top: 24px;\n        left: 48px;\n        border-radius: 0 6px 6px 0;\n        border-left: none;\n      }\n      .turn-down {\n        top: 48px;\n        left: 24px;\n        border-radius: 0 0 6px 6px;\n        border-top: none;\n      }\n      .ant-btn-icon-only {\n        width: 20px;\n        height: 20px;\n        border: none;\n        color: #747487;\n        border-radius: 5px;\n        &:hover {\n          background: #ffffff17;\n          color: #fff;\n        }\n        &:active {\n          background: #ffffff2e;\n          color: #fff;\n        }\n      }\n    }\n  }\n}\n.remote-control-dropdown {\n  position: absolute;\n  top: 3vh;\n  left: 3vw;\n  width: 30px !important;\n  height: 30px !important;\n  border: none;\n  > * {\n    font-size: 18px !important;\n    color: #439a97;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
